import {
  Group,
  PerspectiveCamera,
  AmbientLight,
  Scene,
  WebGLRenderer,
  sRGBEncoding,
} from "three";

import { ResourcesOptions, XYZ } from "./resources";
import TWEEN from "@tweenjs/tween.js";
import { AllRes } from "./utils";

class SuperGround {
  renderer: WebGLRenderer;
  animationFrameId: number = 0;
  camera: PerspectiveCamera;
  ground: Group;
  scene: Scene;
  shouldRotate: boolean = false;

  constructor(
    canvasElement: HTMLCanvasElement,
    public res: ResourcesOptions,
    public loaderManager: AllRes
  ) {
    // 资源和配置
    this.res = res;

    // 初始化渲染器
    this.renderer = new WebGLRenderer({
      alpha: true,
      antialias: true,
      canvas: canvasElement,
    });
    this.renderer.shadowMap.enabled = true;
    // 重点(从 GLTF 格式加载进来的模型，必须设置颜色空间，不然会出现颜色问题，神坑)
    this.renderer.outputEncoding = sRGBEncoding;

    // 添加各个部件
    this.camera = new PerspectiveCamera(); // 视角
    this.ground = new Group(); // 地球
    this.scene = new Scene();

    this.scene.add(this.camera);
    this.scene.add(this.ground);
    this.scene.add(new AmbientLight("white", 5));

    // 具体设置每个部件
    this.setGround();
    this.setCamera();

    // 更新大小
    this.updateSize();
  }
  // 循环器
  animate(time?): void {
    this.render(time);
    this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
  }
  // 渲染部分
  render(time): void {
    this.renderer.render(this.scene, this.camera);

    this.updateRotate();

    TWEEN.update(time);
  }
  updateRotate() {
    if (this.shouldRotate) {
      this.camera.lookAt(this.res.groundCameraLookAt);
      this.ground.rotateZ(this.res.groundCameraAutoRotateSpeed);
    }
  }

  setGround() {
    this.loaderManager.groundModel.then((model) => {
      const obj = model.scene;
      this.ground.add(obj);
    });
  }
  // 视角设置
  setCamera() {
    // 初始化位置
    this.camera = new PerspectiveCamera();
    this.camera.position.copy(this.res.groundCameraInitPos)
    this.camera.lookAt(this.res.groundCameraLookAt);

    this.camera.fov = 50;
    this.camera.far = 1000;
    this.camera.near = 0.01;
  }
  // 更新视角大小
  updateSize(): void {
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
  }
  zoomIn() {
    new TWEEN.Tween({
      x: this.camera.position.x,
      y: this.camera.position.y,
      z: this.camera.position.z,
    })
      .onUpdate((o: XYZ) => {
        this.camera.position.set(o.x, o.y, o.z);
      })
      .onComplete((o: XYZ) => {
        this.afterZoomInShift();
      })
      .to(
        {
          x: 0,
          y: 0,
          z: 1,
        },
        600
      )
      .start();
  }
  afterZoomInShift() {
    new TWEEN.Tween({
      x: this.camera.position.x,
      y: this.camera.position.y,
      z: this.camera.position.z,
    })
      .onUpdate((o: XYZ) => {
        this.camera.position.set(o.x, o.y, o.z);
        this.camera.lookAt(this.res.groundCameraLookAt);
      })
      .onComplete((o: XYZ) => {
        this.shouldRotate = true;
      })
      .to(
        {
          x: 0,
          y: -0.5,
          z: 1,
        },
        2000
      )
      .start();
  }
  zoomOut() {
    this.shouldRotate = false;
    new TWEEN.Tween({
      x: this.camera.position.x,
      y: this.camera.position.y,
      z: this.camera.position.z,
    })
      .onUpdate((o: XYZ) => {
        this.camera.position.set(o.x, o.y, o.z);
        this.camera.lookAt(this.res.groundCameraLookAt);
      })
      .to(
        {
          x: this.res.groundCameraInitPos.x,
          y: this.res.groundCameraInitPos.y,
          z: this.res.groundCameraInitPos.z,
        },
        300
      )
      .start();
  }
}
export default SuperGround;
